import Grid from '../components/grid'
import Container from '../components/ui/container'
import Text from '../components/ui/text'
import { CMSLink } from '../v2/components/CMSLink'
import { Page } from '@telesoft/types/payload-types'
import React, { Fragment, ReactElement } from 'react'

export type StandaloneHeaderClusterBlockProps = Extract<
  Page['blocks'][0],
  { blockType: 'standalone-header-cluster' }
>

export default function StandaloneHeaderCluster(
  block: StandaloneHeaderClusterBlockProps,
): ReactElement {
  const { title, subTitle, options } = block

  const Component = (
    <Fragment>
      <Grid className="gap-0 place-content-center lg:gap-x-8">
        <div
          id={options?.elementId}
          className="flex flex-col col-span-full md:col-span-4 lg:col-span-6 xl:col-span-7"
        >
          <h5 className="mb-1 lg:mb-2 text-opacity-50">{subTitle}</h5>
          <Text variant="subHeading">{title}</Text>
        </div>
        {options?.hasButtons && (
          <div className="col-span-full flex flex-col md:col-span-4 lg:flex-row md:justify-between items-center lg:col-span-6 xl:col-span-5 lg:justify-end mt-4">
            {options?.buttons &&
              options.buttons.map((btn: any, i: number, arr: any) => {
                const { link, options } = btn

                const isLast = arr.length - 1 === i ? true : false

                const isMany = arr.length > 1 ? true : false

                return (
                  <CMSLink
                    {...link}
                    key={i}
                    className={`sm:mb-8 ${isMany && 'w-full'} lg:mb-0 ${!isLast && ' lg:mr-8'}`}
                  />
                )
              })}
          </div>
        )}
      </Grid>
      <div
        className={`h-[1px] bg-black col-span-full md:col-span-8 lg:col-span-full xl:col-span-full my-4 md:my-6 lg:my-8 xl:my-10`}
      />
    </Fragment>
  )

  const RenderedComponent = options?.container ? <Container>{Component}</Container> : Component

  return RenderedComponent
}
